import gql from 'graphql-tag';

export const GET_SNACKBAR_STATE = gql`
  query SnackBar {
    snackBar @client {
      type
      message
      isOpen
    }
  }
`;
